'use client';

import Image from 'next/image';
import type { ReactNode } from 'react';

import { useBrandName } from '@/components/layout/brand-context';

/**
 * Шапка карточки входа, регистрации и восстановления.
 *
 * У AiSearch вместо значка и слова «AiSearch» стоит сам логотип (правка
 * владельца 28.09): имя, набранное крупным шрифтом, дублировало логотип в
 * шапке сайта и читалось как заголовок чужой формы. Заголовок страницы
 * при этом остаётся для читалок и поисковика, просто визуально скрыт.
 *
 * У остальных продуктов своего логотипа-картинки нет, там всё как было:
 * значок и имя продукта.
 */
export function ShapkaVhoda({ znachok }: { znachok: ReactNode }) {
  const brand = useBrandName();

  if (brand === 'AiSearch') {
    return (
      <>
        <Image
          src="/icons/aisearch/logo-115.png"
          alt=""
          width={64}
          height={64}
          className="h-16 w-16 mx-auto mb-5"
          priority
        />
        <h1 className="sr-only">{brand}</h1>
      </>
    );
  }

  return (
    <>
      <div className="w-12 h-12 rounded-xl bg-[var(--color-brand-500)]/10 flex items-center justify-center mb-5 mx-auto">
        {znachok}
      </div>
      <h1 className="text-3xl font-bold mb-2">{brand}</h1>
    </>
  );
}
